import styled from '@emotion/styled';

import CustomTooltip from '@/components/ToolTip/CustomTooltip';
import { useSingleAnalytic } from '@/services/analytics';
import { ERROR_KINDS } from '@/state/layout/moderation';

import ManualReview from './common/ManualReview';
import ViolationModal from './ViolationModal';

interface Props {
    onClose: () => void;
    image: string;
    kind: (typeof ERROR_KINDS)[keyof typeof ERROR_KINDS];
}

const ImageContainer = styled.div`
    overflow: hidden;
    border-radius: 8px;
`;

const Image = styled.div<{ src: string }>`
    height: 20rem;
    min-height: 5rem;
    aspect-ratio: 2/1;
    background: url(${props => props.src}) no-repeat center center;
    background-size: cover;
    width: 100%;
    height: 100%;
    filter: blur(3px);
`;

const TextP = styled.p`
    font-weight: 400;
    font-size: 1.6rem;
    width: 100%;

    & span {
        text-decoration: underline;
        font-weight: bold;
    }
`;

const guildLinesText = `Please keep your script professional and business-related. Political, sexual, personal, criminal, and discriminatory content will not be tolerated or approved.`;

const TextComponent = ({ kind }: Partial<Props>) => {
    return kind === ERROR_KINDS.CelebrityDetectedError ? (
        <TextP>
            It seems that you’re trying to upload a famous figure’s image which is not according to our{' '}
            <CustomTooltip title={guildLinesText}>content guidelines</CustomTooltip>. To resolve the issue, upload new image and try again.
        </TextP>
    ) : (
        <TextP>
            It seems that the photo you’re trying to upload contains elements that are violating our{' '}
            <CustomTooltip title={guildLinesText}>content guidelines</CustomTooltip>. To resolve the issue, upload new image and try again.
        </TextP>
    );
};

export const ImageModeration = ({ onClose, image, kind }: Props) => {
    useSingleAnalytic(mixpanel => mixpanel?.track('image-moderation', { event: 'view', kind }));

    return (
        <ViolationModal onClose={onClose} title="Image Violation Detected">
            <TextComponent kind={kind} />
            <ImageContainer>
                <Image src={image} />
            </ImageContainer>
            <TextP>
                <ManualReview kind={kind} />
            </TextP>
        </ViolationModal>
    );
};
